import { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import Reveal from "../components/Reveal";

const VIDEO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/5ccc464cfeb47494_It%20has%20been%204%20years%20and%20it%20feels%20just%20like%20yesterday%21There%20is%20nothing%20that%20music%20and%20love%20cant.mp4";

export default function VideoFeature() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play().catch(() => {});
  };

  return (
    <section data-testid="video-feature-section" className="relative w-full bg-[#050505]">
      <div className="pad-x pb-10 pt-24 md:pt-32">
        <Reveal>
          <span className="overline">Celebrating Four Years</span>
          <h2 className="display-title mt-3 text-white">
            There's nothing <span className="italic text-gold">music &amp; love</span> can't do
          </h2>
        </Reveal>
      </div>

      <Reveal>
        <div className="relative w-full bg-black">
          <video
            ref={videoRef}
            data-testid="video-feature-video"
            src={VIDEO_URL}
            poster="/video-feature-poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            className="mx-auto block max-h-[85vh] w-auto max-w-full"
          />
          <button
            type="button"
            data-testid="video-sound-toggle"
            onClick={toggleMute}
            aria-label={muted ? "Turn sound on" : "Turn sound off"}
            className="absolute bottom-5 right-5 inline-flex items-center gap-2 rounded-full border border-white/20 bg-black/50 px-4 py-2 text-[0.65rem] uppercase tracking-[0.2em] text-white/80 backdrop-blur-md transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}
            {muted ? "Sound off" : "Sound on"}
          </button>
        </div>
      </Reveal>
    </section>
  );
}
